// Progressive enhancement only: every form and link here works without JavaScript.
document.documentElement.classList.add('js');
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

const header = document.getElementById('siteHeader');
const onScroll = () => header?.classList.toggle('scrolled', window.scrollY > 24);
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });

document.addEventListener('click', (e) => {
  // Quantity steppers
  const qty = e.target.closest('[data-qty]');
  if (qty) {
    const input = qty.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (qty.dataset.qty === 'plus' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }
  // Same-page links (e.g. Order now → #order) move keyboard focus to the section they scroll to
  const link = e.target.closest('a[href*="#"]');
  if (!link || link.pathname !== location.pathname || link.host !== location.host) return;
  const target = link.hash && document.getElementById(decodeURIComponent(link.hash.slice(1)));
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
  history.replaceState(null, '', link.hash);
});

document.addEventListener('change', (e) => {
  // Cart quantities save straight away (a page reload with updated totals); Remove handles taking an item out.
  if (e.target.matches('[data-cart-qty]')) {
    const form = e.target.form;
    form.requestSubmit(form.querySelector('[name="update"]'));
    form.querySelectorAll('button').forEach((b) => { b.disabled = true; }); // after submit: disabled buttons aren't sent
    return;
  }
  if (!e.target.matches('[data-variant-select]')) return;
  const price = e.target.selectedOptions[0]?.dataset.price;
  const target = e.target.form.querySelector('[data-price]');
  if (price && target) target.textContent = price;
});

// Native POST to /cart/add redirects to /cart on success but shows a bare error page on failure
// (e.g. not enough stock), so add via AJAX to keep errors inline. Falls back to the native POST.
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-product-form]');
  if (!form) return;
  e.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const message = form.querySelector('[data-form-message]');
  const label = button.innerHTML;
  button.disabled = true;
  button.textContent = 'Adding to cart…';
  message.textContent = '';
  try {
    const root = window.Shopify?.routes?.root || '/';
    const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Sorry, this item could not be added to your cart.');
    window.location.href = form.dataset.cartUrl;
  } catch (err) {
    // Shopify's own messages (e.g. stock limits) are shown as-is; network or parsing failures get a plain explanation.
    message.textContent = err.name === 'Error' ? err.message : 'Something went wrong. Check your connection and try again.';
    button.disabled = false;
    button.innerHTML = label;
  }
});

// Mobile Order now bar: hidden while the hero or the purchase section is on screen (one primary action per viewport).
const bar = document.querySelector('[data-buy-bar]');
if (bar) {
  const onScreen = new Set();
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => (en.isIntersecting ? onScreen.add(en.target) : onScreen.delete(en.target)));
    bar.classList.toggle('is-hidden', onScreen.size > 0);
  });
  document.querySelectorAll('.hero, [data-purchase-section]').forEach((el) => io.observe(el));
}
